import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { recommendationsServiceSelector } from 'selectors/recommendationsService/recommendationsServiceSelector';
import RecommendationsServiceActions from 'actions/RecommendationsServiceActions';

export const useGraphSimilarProductRecommendations = () => {
    const dispatch = useDispatch();
    const { recommendations = {} } = useSelector(recommendationsServiceSelector);
    const [isFetching, setIsFetching] = useState(false);

    const updateRecommendations = async payload => {
        if (!payload) {
            return;
        }

        try {
            setIsFetching(true);
            await dispatch(RecommendationsServiceActions.fetchSimilarProductRecommendations(payload));
        } finally {
            setIsFetching(false);
        }
    };

    return {
        isFetching,
        recommendations,
        updateRecommendations
    };
};
